import { useSelector } from "react-redux";

import { Courses } from "./components";
import { GuidedTour } from "../../../components/GuidedTour";
import { ROLES } from "../../../utils";

export const Dashboard = () => {
  const { user, userCourses } = useSelector((state) => state);

  const courses = userCourses || [];

  const activeCourses =
    courses.filter(
      (course) => course.is_active
    ).length;

  const completedCourses =
    courses.filter(
      (course) => course.finished
    ).length;

  const inProgressCourses =
    courses.filter(
      (course) =>
        course.is_active &&
        !course.finished &&
        Number(
          course.percentage_course || 0
        ) > 0
    ).length;

  return (
    <>
      {user?.roleId === ROLES.user && (
        <GuidedTour user={user} />
      )}

      <div className="modern-dashboard-page">

        <section className="modern-welcome-card anim">

          <div className="modern-welcome-copy">

            <span className="modern-eyebrow">
              CENTRO DE CAPACITACIÓN
            </span>

            <h1>
              Hola, {user?.name}
            </h1>

            <p>
              Continúa desarrollando tus conocimientos y consulta
              el avance de tus cursos desde un solo lugar.
            </p>

          </div>

          {user?.roleId === ROLES.user && (
            <div className="modern-dashboard-stats">

              <div className="modern-stat-card">
                <div className="modern-stat-icon">
                  <i className="fas fa-book-open" />
                </div>

                <div>
                  <strong>
                    {activeCourses}
                  </strong>
                  <span>
                    Cursos activos
                  </span>
                </div>
              </div>

              <div className="modern-stat-card">
                <div className="modern-stat-icon">
                  <i className="fas fa-play" />
                </div>

                <div>
                  <strong>
                    {inProgressCourses}
                  </strong>
                  <span>
                    En progreso
                  </span>
                </div>
              </div>

              <div className="modern-stat-card">
                <div className="modern-stat-icon">
                  <i className="fas fa-check" />
                </div>

                <div>
                  <strong>
                    {completedCourses}
                  </strong>
                  <span>
                    Completados
                  </span>
                </div>
              </div>

            </div>
          )}

        </section>

        {user?.roleId === ROLES.user && (
          <section className="modern-dashboard-section">

            <div className="modern-section-heading">

              <div>
                <span className="modern-section-eyebrow">
                  APRENDIZAJE
                </span>

                <h2>
                  Mis cursos
                </h2>

                <p>
                  Consulta tu avance y continúa donde te quedaste.
                </p>
              </div>

              <div className="modern-course-counter">
                {courses.length}

                <span>
                  {courses.length === 1
                    ? " curso"
                    : " cursos"}
                </span>
              </div>

            </div>

            <Courses />

          </section>
        )}

        {user?.roleId === ROLES.admin && (
          <section className="modern-dashboard-section">
            <Courses />
          </section>
        )}

      </div>
    </>
  );
};
